import { ProductsResponse } from 'app/shared/models/product-response.model';
import { store } from 'app/shared/store/store';

export const setPromoInStore = (response: ProductsResponse): void => {
  const isPromoValid = !!response?.promotionPage?.isPromoValid;
  if (isPromoValid) {
    store.set('promotionPage', response?.promotionPage);
  }
};
